import React from "react";
import bonus from "../../components/lendinglist.png";
import pdf from "./Bella_Sloan_Secret_Lenders_List.pdf";

function LendingList() {
  return (
    <div className="container">
      <div className="banner">
        <img src={bonus} alt="" />
      </div>

      <div className="container_body">
        <div className="course">
          <h1>Bella Sloan Secret Lending List</h1>
          <p>
            <a href="https://docs.google.com/document/d/1Lc9GfGJ7dUe5C7PsjO___qXEMazCXwc7QnSWGLt1cms/edit?tab=t.0">
              Big 3- Lenders List
            </a>
          </p>
        </div>
        <div className="downloads">
          <h3>Downloads</h3>
          <a href={pdf}>Bella_Sloan_Secret_Lenders_List.pdf</a>
        </div>
      </div>
    </div>
  );
}

export default LendingList;
